export default function Hero() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-background-50 via-background-100 to-background-50"></div>
      <div className="absolute top-0 right-0 w-full md:w-3/5 h-full opacity-20 md:opacity-30">
        <div className="absolute inset-0 bg-gradient-to-l from-primary-500/20 via-accent-500/10 to-transparent"></div>
        <div className="absolute top-20 right-10 w-72 h-72 rounded-full bg-primary-500/10 blur-3xl"></div>
        <div className="absolute bottom-20 right-40 w-96 h-96 rounded-full bg-accent-500/8 blur-3xl"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-0">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/15 border border-primary-500/25 mb-5">
              <i className="ri-fire-line text-primary-500 text-sm"></i>
              <span className="text-primary-400 text-xs font-medium">全网热播剧集 · 每日同步更新</span>
            </div>

            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-heading font-black text-foreground-950 leading-tight mb-4">
              6080新视觉影院
              <br />
              <span className="text-primary-500">高清流畅免费追剧平台</span>
            </h1>

            <p className="text-foreground-400 text-sm md:text-base max-w-xl mb-2 leading-relaxed">
              6080新视觉影院专注电视剧全集免费在线观看，覆盖国产剧、港台剧、韩剧、美剧、日剧等全品类热播资源。平台采用多线CDN加速与H.265智能编码技术，确保最新电视剧高清不卡顿，观看流畅不缓冲。
            </p>
            <p className="text-foreground-400 text-sm md:text-base max-w-xl mb-6 leading-relaxed">
              每日同步首播剧集，秒开即播，免费看全集无广告打断。无论热门IP改编还是经典老剧重温，一站式满足你的追剧需求。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-7">
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-500/15">
                  <i className="ri-tv-line text-accent-500 text-base"></i>
                </span>
                <div>
                  <div className="text-foreground-800 font-bold text-sm">20000+</div>
                  <div className="text-foreground-500 text-xs">部剧集资源</div>
                </div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500/15">
                  <i className="ri-flashlight-line text-primary-500 text-base"></i>
                </span>
                <div>
                  <div className="text-foreground-800 font-bold text-sm">每日同步</div>
                  <div className="text-foreground-500 text-xs">首播更新</div>
                </div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-500/15">
                  <i className="ri-shield-check-line text-secondary-500 text-base"></i>
                </span>
                <div>
                  <div className="text-foreground-800 font-bold text-sm">多线加速</div>
                  <div className="text-foreground-500 text-xs">秒开不卡</div>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                onClick={(e) => handleClick(e, '#ranking')}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-950 font-semibold text-sm rounded-lg transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                热门排行
              </a>
              <a
                href="#updates"
                onClick={(e) => handleClick(e, '#updates')}
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 hover:bg-background-200 border border-background-300/60 text-foreground-700 font-semibold text-sm rounded-lg transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-timer-line text-lg"></i>
                最新更新
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-primary-500/20 via-accent-500/10 to-primary-500/5 rounded-2xl blur-xl"></div>
              <div className="relative rounded-xl overflow-hidden border border-background-200/60 bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20composition%20with%20glowing%20golden%20film%20reels%20and%20soft%20light%20streaks%20on%20black%20background%2C%20elegant%20film%20texture%20overlay%2C%20warm%20amber%20highlights%2C%20cinematic%20atmosphere%2C%20professional%20movie%20industry%20aesthetic%2C%20luxurious%20dark%20tones%20with%20subtle%20lens%20flares&width=600&height=500&seq=hero-cinema-main&orientation=landscape"
                  alt="6080新视觉影院 - 高清流畅追剧体验"
                  className="w-full h-auto object-cover"
                  width="600"
                  height="500"
                />
              </div>

              <div className="absolute -bottom-4 -left-4 bg-background-50/95 backdrop-blur-md border border-background-200/60 rounded-lg px-4 py-3 shadow-sm hidden md:block">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500/15">
                    <i className="ri-movie-line text-accent-500 text-lg"></i>
                  </div>
                  <div>
                    <div className="text-foreground-800 font-semibold text-sm whitespace-nowrap">热播推荐</div>
                    <div className="text-foreground-500 text-xs">每日精选好剧</div>
                  </div>
                </div>
              </div>

              <div className="absolute -top-3 -right-3 bg-background-50/95 backdrop-blur-md border border-background-200/60 rounded-lg px-4 py-2.5 shadow-sm hidden md:block">
                <div className="flex items-center gap-2">
                  <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></span>
                  <span className="text-foreground-700 text-xs font-medium whitespace-nowrap">同步更新中</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}